import { render } from "./NosOffresPage.vue?vue&type=template&id=40aafac8"
import script from "./NosOffresPage.vue?vue&type=script&lang=js"
export * from "./NosOffresPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__